import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";

export const HouseDialog = ({ open, onOpenChange, title, description, children, testId, wide }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent
      data-lenis-prevent
      data-testid={testId}
      className={`house-dialog ${wide ? "max-w-3xl" : "max-w-xl"}`}
    >
      <DialogTitle className="house-dialog-title">{title}</DialogTitle>
      {description ? <DialogDescription className="house-dialog-desc">{description}</DialogDescription> : null}
      <div className="house-dialog-body">{children}</div>
    </DialogContent>
  </Dialog>
);
